import React, { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import dashboardServices from "../../requests/admin/DashboardServices";
import { toast } from "react-toastify";
import Loader from "../Loader";

ChartJS.register(ArcElement, Tooltip, Legend);

const generateColors = (count) => {
  const colors = [];
  const hue = Math.random() * 360;

  for (let i = 0; i < count; i++) {
    const hueValue = (hue + (i * 360) / count) % 360;
    const color = `hsl(${hueValue}, 70%, 65%)`;
    colors.push(color);
  }
  return colors;
};

const DoughnutReport = ({chartData, timeFrame, setTimeFrame, setChartData}) => {
  const [chartDataLoading, setChartDataLoading] = useState(true);
  
  useEffect(()=>{
    const fetchData = async()=>{
      setChartDataLoading(true);
      try{
        const response = await dashboardServices.fetchChartData({
          timeFrame: timeFrame
        })
        
        if(response.status === "000"){
          setChartData(response.data.data);
        }else{
          toast.error(response.message || "An error occurred while fetching chart data")
        }
      }catch(error){
        toast.error(error.response?.data?.data?.reason || "An error occurred while fetching chart data")
      }finally{
        setChartDataLoading(false);
      }
    }
    fetchData();
  },[timeFrame, setChartData, setChartDataLoading])

  const handleTimeFrame = (timeFrame)=>{
    setTimeFrame(timeFrame);
  }
  const backgroundColors = generateColors(chartData?.labels.length);

  const data = {
    labels: chartData?.labels,
    datasets: [
      {
        data:[chartData.counts.Active, chartData.counts.Promote, chartData.counts.Pending, chartData.counts.Expired],
        backgroundColor: backgroundColors,
        hoverBackgroundColor: backgroundColors.map((color) => {
          return color.replace("65%", "55%");
        }),
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        display: false,
      },
    },
    cutout: "75%",
    animation: {
      animateRotate: false,
      animateScale: false,
    },
    layout: {
      padding: 0,
    },
  };

  if(chartDataLoading){
    return <Loader />
  }

  return (
    <div className="px-4 py-4 bg-white rounded-lg shadow-lg">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-lg font-semibold">Deals Overview</h2>
        <select
          value={timeFrame}
          onChange={(e) => handleTimeFrame(e.target.value)}
          className="px-3 py-2 text-sm text-gray-700 bg-white rounded-md border focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option className="hover:bg-[#FF6C6C] hover:text-white" value="Daily">
            Daily
          </option>
          <option
            className="hover:bg-[#FF6C6C] hover:text-white"
            value="Weekly"
          >
            Weekly
          </option>
          <option
            className="hover:bg-[#FF6C6C] hover:text-white"
            value="Monthly"
          >
            Monthly
          </option>
          <option
            className="hover:bg-[#FF6C6C] hover:text-white"
            value="Lifetime"
          >
            Lifetime
          </option>
        </select>
      </div>

      <div className="grid grid-cols-2 gap-1 mb-16 md:grid-cols-4">
        {data.labels.map((label, index) => (
          <div
            key={label}
            className="flex col-span-1 items-center text-[10px] text-gray-500"
          >
            <div
              className="mr-1 w-3 h-3 rounded-full"
              style={{
                backgroundColor: data.datasets[0].backgroundColor[index],
              }}
            ></div>
            <span>{label}</span>
          </div>
        ))}
      </div>

      <div className="flex overflow-hidden relative justify-center items-center my-4 h-72">
        <div className="relative w-[280px] h-[280px] bg-gray-100 rounded-full flex items-center justify-center max-w-full max-h-full">
          <div className="bg-white rounded-full h-[150px] w-[150px] absolute"></div>
          <div className="relative w-[250px] h-[250px] max-w-full max-h-full">
            <Doughnut data={data} options={options} height={250} width={250} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoughnutReport;
